import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Modal from 'react-modal'
import ReactPlayer from 'react-player'
import Styles from './VideoModal.css'

@CSSModules(Styles,{allowMultiple:true})
export default class VideoModal extends Component {
  static propTypes = {
    vimeoId: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false
    }
  }
  openModal = () =>{
    this.setState({ modalOpen: true })
  }
  closeModal = () =>{
    this.setState({ modalOpen: false })
  }

  render() {
    if (!this.props.vimeoId) {
      return null
    }

    return (
      <span>
        <span onClick={this.openModal} styleName='modal-opener'>
          {this.props.children}
        </span>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel='Video player'
          style={{
            overlay : {
              backgroundColor   : 'rgba(0, 0, 0, 0.75)'
            },
            content: {
              position                   : 'absolute',
              top                        : '50%',
              left                       : 0,
              right                      : 0,
              bottom                     : 'auto',
              marginLeft                 : 'auto',
              marginRight                : 'auto',
              width                      : '640px',
              maxWidth                   : '90%',
              border                     : '0px',
              background                 : '#fff',
              overflow                   : 'visible',
              WebkitOverflowScrolling    : 'touch',
              borderRadius               : 0,
              outline                    : 'none',
              transform                  : 'translateY(-50%)',
              padding                    : 0
            }
          }}>
          <div styleName='family-modal-wrap'>
            <div styleName='family-modal-flex'>
              <div styleName='media-react-player-wrap'>
                <ReactPlayer
                  url={'https://vimeo.com/'+this.props.vimeoId}
                  volume={0.5}
                  playing
                  loop
                />
              </div>
            </div>
            <div
              styleName='family-modal-close-wrap'
              onClick={this.closeModal}
            >
              <div
                styleName='family-modal-close'
                className='fa fa-times'
              />
            </div>
          </div>
        </Modal>
      </span>
    )
  }
}

